//@ts-check
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import { errorHandler } from '../ajax';
import createBatchAction from '@/common/lib/create-batch-action';
import { openFailedDialog, openSuccessDialog } from '@/common/components/kf-dialog';
import { STATUS_FAILURE_NO_HIME, STATUS_FAILURE_NO_OFFICE, STATUS_FAILURE_NO_TARGET, STATUS_FAILURE_TOP_REGISTERDONE } from '@/common/constants';

export const ntfyRegisterUrlRequest = createBatchAction('@@login/NTFY_REGISTER_URL_REQUEST', () => [showLoading()]);
export const ntfyRegisterUrlSuccess = createBatchAction('@@login/NTFY_REGISTER_URL_SUCCESS', () => [
  hideLoading(),
  openSuccessDialog('受信登録が完了しました。')
]);
export const ntfyRegisterUrlFailure = createBatchAction('@@login/NTFY_REGISTER_URL_FAILURE', (err) => [
  hideLoading(), 
  urlFailureHandler(err)
]);


const urlFailureHandler = (e) => {
  switch (e.status) {
    case STATUS_FAILURE_NO_TARGET:
    case STATUS_FAILURE_NO_OFFICE:
    case STATUS_FAILURE_NO_HIME:
      return openFailedDialog('urlの期限が切れています。');
    case STATUS_FAILURE_TOP_REGISTERDONE:
      return openFailedDialog('URLが使用済みです。');
    default:
      return errorHandler(e);
  }
};